import { computed, ref, watch } from 'vue';
import { debounce } from 'lodash';
import { useI18n } from '@/composables';
import { $emitter } from '@/services/emitter';

type ThreePanelCategoryListProps = {
  prefix: string;
  selectedBrands: string[];
  brandSelectAllIndex: Record<string, boolean>;
  selectedKeysIndex: Record<string, boolean>;
  data: Array<{ name: string }>;
  selected: Array<{ name: string }>;
  firstPanel?: boolean;
};

export const useFlowThreePanelCategoryList = (props: ThreePanelCategoryListProps) => {
  const { t } = useI18n();

  const searchBrand = ref('');
  const pSearchBrand = ref('');
  const autoVirtualScrollAt = 50;

  const noEvents = computed(() => props.data.length < autoVirtualScrollAt);

  const setSearchBrand = (value: string) => {
    pSearchBrand.value = value;
  };

  const setSearchBrandDebounced = debounce(setSearchBrand, 300);

  watch(searchBrand, (value) => {
    setSearchBrandDebounced(value);
  });

  watch(
    () => props.selected,
    (value) => {
      $emitter.emit(`${props.prefix}-selected-keys`, value.map((item) => item.name));
    },
    { deep: true },
  );

  watch(
    () => props.selectedBrands,
    (value) => {
      $emitter.emit(`${props.prefix}-selected-brands`, value);
    },
    { deep: true },
  );

  const items = computed(() => {
    if (pSearchBrand.value) {
      return props.data
        .filter((item) => item.name.toLowerCase().includes(searchBrand.value.toLowerCase()))
        .slice(0, 100);
    }

    return props.data;
  });

  return {
    t,
    searchBrand,
    items,
    noEvents,
  };
};
